import { Grid, Typography } from '@mui/material';
import React from 'react';

export default ({ title, color }) => {
  return (
    <Grid container direction="row" style={{ marginBottom: 20 }}>
      <div style={{ width: 8, backgroundColor: color, marginRight: 5 }}></div>
      <Typography
        variant="h4"
        fontSize={'bold'}
        style={{ fontWeight: 'bold', color: 'black' }}
      >
        {title}
      </Typography>
    </Grid>
  );
};
